import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import GoalTenYear from '../../../widgets/goalTenYear/GoalTenYear'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import ComplianceObjectives from '../../../widgets/complianceObjectives/ComplianceObjectives'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getProposalGoal } from '../../../redux/actions/proposalGoal'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function ProposalGoal() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  const projectId = sessionStorage.getItem('projectId')

  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.targetSetting}`,
    pathNameForward: `${pathname.proposal.projectTypeInfo}`,
  }

  useEffect(() => {
    if (projectId) handleGetSchema(projectId)
    else setError({ statusCode: 404, errorMessage: ERR_MSG_404_PROJECT_ID })
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProposalGoal(proposalId)
      setSchema(_schema)
      setIsEditWidget({
        goalTenYear:
          _schema.model.forms.goalTenYear.optionSelected.length > 0 ||
          _schema.model.forms.goalTenYear?.inputOther?.value
            ? false
            : true,
        complianceObjective:
          _schema.model.forms.complianceObjective.optionSelected.length > 0 ? false : true,
      })
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getProposalGoal(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  if (error)
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )

  if (!schema || isLoading)
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )

  // 🚩 ก้อนที่ 1: จับข้อมูล "เวอร์ชันปัจจุบัน" มัดรวมไว้ในตัวแปรนี้ จะได้ไม่ต้องเขียนโค้ดซ้ำ 2 รอบ
  const renderCurrentVersion = (
    <div className="top">
      {schema?.model?.forms?.goalTenYear && (
        <>
          <GoalTenYear
            showCommandButton={!schema.model.forms.goalTenYear.disabled}
            schema={schema.model.forms.goalTenYear}
            isEdit={isEditWidget.goalTenYear}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('goalTenYear', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {schema?.model?.forms?.complianceObjective && (
        <>
          <ComplianceObjectives
            showCommandButton={!schema.model.forms.complianceObjective.disabled}
            schema={schema.model.forms.complianceObjective}
            isEdit={isEditWidget.complianceObjective}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('complianceObjective', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.model.header} subHeader={schema.model.subHeader} />

      <ViewPreviousVersionButon
        handleGetSchemaPrevious={handleGetSchemaPrevious}
        isViewPrevious={isViewPrevious}
        masterSubjectId={'1-1003,1-1004,1-1005,5-5003'}
      />

      {!schema.model.forms.goalTenYear.disabled &&
        !schema.model.forms.complianceObjective.disabled && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            routing={buttonRoute}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            editWidget={isEditWidget}
            forms={schema?.model?.forms}
          />
        )}

      <div className="wrapper">
        {/* ==============================================
             ก้อนที่ 1: แสดงข้อมูลปัจจุบัน (สลับมี/ไม่มี Panel)
            ============================================== */}
        <div style={!isViewPrevious ? { width: '100%' } : {}}>
          {isViewPrevious ? (
            <Panel
              //classPrefix="view-version-panel"
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
            >
              {renderCurrentVersion}
            </Panel>
          ) : (
            renderCurrentVersion
          )}
        </div>

        {/* ==============================================
            ก้อนที่ 2: แสดงข้อมูลก่อนหน้า (แสดงเฉพาะตอนกดปุ่ม)
            ============================================== */}
        {isViewPrevious && schemaPrevious && (
          <>
            <div className="line" />
            <div>
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ก่อนหน้า'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed' }}
            >
              <div className="bottom">
                {schemaPrevious?.model?.forms?.goalTenYear && (
                  <>
                    <GoalTenYear
                      showCommandButton={false}
                      schema={schemaPrevious.model.forms.goalTenYear}
                      isEdit={false}
                    />
                    <br />
                  </>
                )}

                {schemaPrevious?.model?.forms?.complianceObjective && (
                  <>
                    <ComplianceObjectives
                      showCommandButton={false}
                      schema={schemaPrevious.model.forms.complianceObjective}
                      isEdit={false}
                    />
                    <br />
                  </>
                )}
              </div>
            </Panel>
            </div>
            <br />
            <br />
          </>
        )}
      </div>
    </SidebarProposal>
  )
}
